import { i18n, RecallTextPath } from "@/i18n"
import { errMsgMap } from "./const/errMsg"

export const Code2Msg = (code: number) => {
    return i18n.getRecall(
        errMsgMap[code as keyof typeof errMsgMap] as RecallTextPath
    )
}
